import React from "react";
import skyline from "../../../img/mediakit/lamina01-skyline.jpg";
import logo from "../../../img/mediakit/wecast-logo-vector.svg";
import styles from "./Lamina01Portada.module.scss";

function Lamina01Portada() {
  return (
    <div className={styles.lamina} data-mk-lamina="portada">
      <img src={skyline} alt="" className={styles.bg} />
      <img src={logo} alt="wecast" className={styles.logo} />
    </div>
  );
}

export default Lamina01Portada;
